import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import {
	EntityRulesContainerGiver,
	GroupsInClientResponse,
	RuleElement,
	WorkersAndAccessGroupsInSettingsGiver,
} from "@/models/interfaces/access/entity-rules";


export class AccessApi {
	static getWorkersAndAccessGroups(): Promise<WorkersAndAccessGroupsInSettingsGiver> {
		const http = new CommonHttp();
		return http
			.get(`v1/access/Settings/GetWorkersAndAccessGroups`)
			.then(data => data.data);
	}

	static getClientAccessRules(clientId: number): Promise<EntityRulesContainerGiver> {
		const http = new CommonHttp();
		return http
			.get(`access/system/rules/${clientId}/client`)
			.then(data => data.data);
	}

	static getProjectAccessRules(projectId: number): Promise<EntityRulesContainerGiver> {
		const http = new CommonHttp();
		return http
			.get(`access/system/rules/${projectId}/project`)
			.then(data => data.data);
	}

	static getGroupsInClient(clientId: number): Promise<GroupsInClientResponse> {
		const http = new CommonHttp();
		return http
			.get(`access/system/groups/client?EntityId=${clientId}`)
			.then(data => data.data);
	}

	static getGroupsInProject(projectId: number): Promise<GroupsInClientResponse> {
		const http = new CommonHttp();
		return http
			.get(`access/system/groups/project?EntityId=${projectId}`)
			.then(data => data.data);
	}

	static saveRuleInClient(
		clientId: number,
		rules: RuleElement[],
		groupId: number,
		ruleType: number,
	): Promise<any> {
		const http = new CommonHttp();
		return http
			.post(`access/system/rule/client`, {
				Id: clientId,
				Rules: rules,
				GroupId: groupId,
				RuleType: ruleType,
			})
			.then(data => data.data);
	}

	static removeRuleInClient(id: number, entityId: number, inherited: boolean, groupId: number): Promise<any> {
		const http = new CommonHttp();
		return http
			.delete(`access/system/client`, {
				Id: id,
				EntityId: entityId,
				Inherited: inherited,
				GroupId: groupId,
			})
			.then(data => data.data);
	}

	static saveRuleInProject(
		projectId: number,
		rules: RuleElement[],
		groupId: number,
		ruleType: number,
	): Promise<any> {
		const http = new CommonHttp();
		return http
			.post(`access/system/rule/project`, {
				Id: projectId,
				Rules: rules,
				GroupId: groupId,
				RuleType: ruleType,
			})
			.then(data => data.data);
	}

	static removeRuleInProject(id: number, entityId: number, inherited: boolean, groupId: number): Promise<any> {
		const http = new CommonHttp();
		return http
			.delete(`access/system/rule/project`, {
				Id: id,
				EntityId: entityId,
				Inherited: inherited,
				GroupId: groupId,
			})
			.then(data => data.data);
	}

	static editGroupOwnage(
		groupId: number,
		clients: boolean,
		entities: number[],
	): Promise<any> {
		const http = new CommonHttp();
		return http
			.post(`v1/access/Ownage/EditGroupOwnage`, {
				GroupId: groupId,
				Clients: clients,
				Entities: entities,
			})
			.then(data => data.data);
	}
}
